import {offerTypes} from "../types/offerTypes";

const initState = {
    offers: [],
    offersListIsLoading: true,
    featuredOffers: [],
    featuredOffersListIsLoading: true,
    mostViewedOffers: [],
    mostViewedListIsLoading: true,
    offersCategories: [],
    offersCategoriesIsLoading: true,
    currentOfferCategory: null,
    offerDetails: null,
    offerDetailsIsLoading: true,
    offersLoading: false,
    noMoreOffers: false,
    offerIdNotFound: false,
};

const specialtyReducer = (state = initState, action) => {
    switch (action.type) {
        case offerTypes.GET_OFFERS :
            state = {
                ...state,
                offersListIsLoading: false,
                offers: [...state.offers, ...action.payload.offers],

            };
            break;
        case offerTypes.OFFER_ID_NOT_FOUND :
            state = {
                ...state,
                offerIdNotFound: true,
            };
            break;
        case offerTypes.FETCHING_MORE_OFFERS:
            state = {
                ...state,
                offersLoading: action.payload,
            };
            break;
        case offerTypes.NO_MORE_OFFERS :
            state = {
                ...state,
                noMoreOffers: action.payload,
            };
            break;
        case offerTypes.GET_FEATURED_OFFERS :
            state = {
                ...state,
                // featuredOffers: action.payload,
                featuredOffers: [...action.payload.featured_offers],
                featuredOffersListIsLoading: false
            };
            break;
        case offerTypes.GET_MOST_VIEWED_OFFERS :

            state = {
                ...state,
                // mostViewedOffers: action.payload,
                mostViewedOffers: [...action.payload.most_viewed_offers
                ],
                mostViewedListIsLoading: false
            };
            break;
        case offerTypes.GET_OFFERS_CATEGORIES :
            state = {
                ...state,
                offersCategories: action.payload,
                offersCategoriesIsLoading: false
            };
            break;
        case offerTypes.GET_OFFER_DETAILS :
            state = {
                ...state,
                offerDetails: action.payload,
                offerDetailsIsLoading: false
            };
            break;
        case offerTypes.SET_OFFER_CATEGORY:
            state = {
                ...state,
                currentOfferCategory: action.payload,
            };
            break;
        case offerTypes.CLEAR_OFFER_CATEGORY:
            state = {
                ...state,
                currentOfferCategory: null,
            };
            break;
        case offerTypes.CLEAR_OFFER_LIST_AND_CATEGORIES :
            state = {
                ...state,
                offers: [],
                offersListIsLoading: true,
                featuredOffers: [],
                featuredOffersListIsLoading: true,
                offersCategories: [],
                offersCategoriesIsLoading: true,
            };
            break;
        case offerTypes.CLEAR_OFFER_DETAILS :
            state = {
                offerDetails: null,
                offerDetailsIsLoading: true,
            };
            break;
        case offerTypes.CLEAR_OFFER_LIST :
            state = {
                ...state,
                offers: [],
                offersListIsLoading: true,
                featuredOffers: [],
                featuredOffersListIsLoading: true,
                mostViewedOffers: [],
                mostViewedListIsLoading: true,
                offersLoading: false,
                noMoreOffers: false,
            };
            break;
        case offerTypes.CLEAR_SHOW_MORE :
            state = {
                ...state,
                noMoreOffers: false,
            };
            break;
        default:
    }

    return state;
};




export default specialtyReducer